import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1327a2fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    disabled: _ctx.carNumber === '',
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkCarNumber && _ctx.checkCarNumber(...args))),
    class: "button-cert"
  }, "확인", 8, _hoisted_1))
}